import { downloadExportFileById } from '../services/exportFileService';

export const downloadExportFile = async (id, fileName, fileType, loadingCallback) => {
  loadingCallback(true);
  try {
    await downloadExportFileById(id, fileType)
      .then(
        (response) =>
          new Blob([response.data], {
            type: fileType,
          }),
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        a.remove();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          loadingCallback(false);
        }, 100);
      });
  } catch (err) {
    loadingCallback(false);
  }
};
